import React from "react";
import "./CardsCourses.css";
import omar from '../../Assets/Images/omar.jpg';
import ListGroup from 'react-bootstrap/ListGroup';
import { BiDotsVerticalRounded } from 'react-icons/bi'
import { MdDeleteOutline } from 'react-icons/md'
import { FaRegEdit } from 'react-icons/fa'
import { Dropdown } from "react-bootstrap";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Crud from "../CrudCours/Crud";
import programmation from '../../Assets/programmation.jpg'
import design from '../../Assets/design.png'
import gestionProjet from '../../Assets/gestionProjet.jpg'
import digital from '../../Assets/digital.png'

function CardsCourses({ titre_cours, infoUser, isApproved, isArchived, domaine, id, elt_collection = 'cours' }) {
  const Affiche = (domaine) => {

    if (domaine.toLowerCase() === 'programmation') {
      return (<img src={programmation} alt="images" className="img123" />)
    } else if (domaine === 'Design') {
      return (<img src={design} alt="images" className="img123" />)
    } else if (domaine === 'Gestion de projet') {
      return (<img src={gestionProjet} alt="images" className="img123" />)
    } else if (domaine === 'Marketing Digital') {
      return (<img src={digital} alt="images" className="img123" />)
    }

  }


  return (
    <div id="cardsCOurses" className=" px-md-3 py-sm-2">
      <ListGroup.Item className="d-flex justify-content-between">
        <div className=" d-flex">
          <div>
            {Affiche(domaine)}
          </div>
          <div className="ps-md-3">
             <p className="message-notif retourLigne">{titre_cours}</p>
            <p className="small">{infoUser}</p>
          </div>
        </div>
        <Crud
          isArchived={isArchived}
          isApproved={isApproved}
          elt_collection={elt_collection}
          id={id}
        />
      </ListGroup.Item>
    </div>
  );
};

export default CardsCourses;

